export default __webpack_public_path__ + "static/media/iyere.67c6a3d8.png";